<div class="card border-0 bg-light">
	<div class="card-body d-flex align-items-center gap-3 p-3 p-md-4">
		<fa-duotone-icon icon="building" size="lg" class="text-muted" secondaryOpacity="0.3" />
		<div class="fw-semibold">{{ message }}</div>
	</div>
</div>
